import React from "react"


const OnlyProButton = (props)=>{

    return (
        <div className={"ueBtnProOnly"}><i className="bi bi-lock"></i> pro</div>
    )

}

export default OnlyProButton
